import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tab-bar__wrap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "tab-bar__top" }
const _hoisted_4 = { class: "tab-bar__list-wrap" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "tab-bar__item"
}
const _hoisted_7 = ["data-target"]
const _hoisted_8 = {
  key: 2,
  class: "tab-bar__item"
}
const _hoisted_9 = { class: "tab-bar__item" }
const _hoisted_10 = ["data-target"]
const _hoisted_11 = { class: "tab-bar__button-wrap" }
const _hoisted_12 = ["href"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "tab-bar__mobile-active",
                onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args))),
                innerHTML: _ctx.activeTab
              }, null, 8 /* PROPS */, _hoisted_5))
            : _createCommentVNode("v-if", true),
          _createElementVNode("ul", {
            class: _normalizeClass([`tab-bar__list`, _ctx.isMobile && `tab-bar__list--mobile`, _ctx.isMobile && _ctx.mobileMenuOpen ? `state-open` : `state-closed`])
          }, [
            (_ctx.groupBy === `StylesFunctions`)
              ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "tab-bar__link state-active",
                    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.scrollDown && _ctx.scrollDown(...args))),
                    "data-target": "stylesContainer"
                  }, _toDisplayString(_ctx.store.state?.categoryName) + " " + _toDisplayString(_ctx.translations.Styles), 1 /* TEXT */)
                ]))
              : (_ctx.groupBy === `Types` && _ctx.store.state?.categorySlug !== `other-products`)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.productTypes, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "tab-bar__item",
                      key: index
                    }, [
                      _createElementVNode("a", {
                        href: "#",
                        class: _normalizeClass([index === 0 && `state-active`, `tab-bar__link`]),
                        onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.scrollDown && _ctx.scrollDown(...args))),
                        "data-target": item.type.slug
                      }, _toDisplayString(item.type.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_7)
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                : (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "tab-bar__link state-active",
                      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.scrollDown && _ctx.scrollDown(...args))),
                      "data-target": "productsContainer"
                    }, _toDisplayString(_ctx.store.state?.categoryName), 1 /* TEXT */)
                  ])),
            (_ctx.staticSections.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.staticSections, (section) => {
                  return (_openBlock(), _createElementBlock("li", _hoisted_9, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.scrollDown && _ctx.scrollDown(...args))),
                      class: "tab-bar__link",
                      "data-target": section.slug
                    }, _toDisplayString(section.title), 9 /* TEXT, PROPS */, _hoisted_10)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("a", {
            href: `${_ctx.translations.CategoryUrl}/${_ctx.store.state?.categorySlug}`,
            class: "btn btn-primary"
          }, _toDisplayString(_ctx.translations.ViewAll) + " " + _toDisplayString(_ctx.store.state?.categoryName), 9 /* TEXT, PROPS */, _hoisted_12)
        ])
      ])
    ])
  ]))
}